import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationEaseOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationEaseOut"><Path d="M20.5 3.5C10.8725 5.58968 5.58968 10.8725 3.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationEaseOut;
